<template>
  <div>
    <div v-on:click="sentResetMailAlert = false">
    <v-alert
      prominent
      type="error"
      v-if="sentResetMailAlert"
      transition="scale-transition"
    >
    <!-- 再設定用メール送信アラート -->
      <v-col class="grow">{{this.texts.mail_sent_error}}
      </v-col>
    </v-alert>
    </div>

    <div v-on:click="enterVefiycodeAlert = false">
    <v-alert
      prominent
      type="error"
      v-if="enterVefiycodeAlert"
      transition="scale-transition"
    >
    <!-- パスワード再設定コード -->
      <v-col class="grow">{{this.texts.password_regulation}}
      </v-col>
    </v-alert>
    </div>

    <h2 class="auth_ttl">
      {{
        getFormState === "refreshPassword"
          ? this.texts.reset_password_mail_title
          : this.texts.change_password_title
      }}
    </h2>
    <v-spacer></v-spacer>
    <p class="reset_top_text" v-if='getFormState === "refreshPassword"'>{{this.texts.mail_sent_1}}</p>
    <p class="reset_top_text" v-if='getFormState === "refreshPasswordSubmit"'>{{this.texts.mail_sent_2}}<br>
    <a href="#"><span class="back_to_sent_code_text" v-on:click="moveToForgotPassword">{{this.texts.mail_sent_3}}</span></a></p>
    <div v-if="getFormState === 'refreshPassword'" class="formcontainer">
      <p id="form-label">{{this.texts.registered_mail}}</p>
      <v-text-field v-model="form.username" solo></v-text-field>
      <button class="btn_next" v-on:click="forgotPassword"
        >{{this.texts.reset_password_mail}}</button>
    </div>

    <div v-if="getFormState === 'refreshPasswordSubmit'" class="formcontainer">
      <p id="form-label">{{this.texts.change_password_mail}}</p>
      {{this.form.username}}
      <br><br>
      <p id="form-label">{{this.texts.reset_code}}</p>
      <v-text-field v-model="form.authCode" solo></v-text-field>
      <p id="form-label">{{this.texts.password}}</p>
      <v-text-field
        solo
        v-model="form.password"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        name="input-10-2"
        :hint=this.texts.password_hint
        class="input-group--focused"
        @click:append="show2 = !show2"
      ></v-text-field>
      <button class="btn_next" v-on:click="forgotPasswordSubmit">{{this.texts.change_password}}</button>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import loginTextJa from "../assets/LoginTextsJa";
import loginTextEn from "../assets/LoginTextsEn";
import loginTextCh from "../assets/LoginTextsCh";

export default {
  computed: {
    returnLanguage() {
        return this.getLanguage
    },
    ...mapGetters(["getFormState","getLanguages","getLanguage"])
  },
  name: "home",
  created() {
    // eslint-disable-next-line
    if(this.getLanguage == "日本語"){
        // eslint-disable-next-line
        this.texts = loginTextJa
    } else if (this.getLanguage == "English"){
        // eslint-disable-next-line
        this.texts = loginTextEn
    } else if (this.getLanguage == "中文"){
        // eslint-disable-next-line
        this.texts = loginTextCh
    }
  },
  data() {
    return {
      show2: false,
      form: {
        username: "",
        authCode: "",
        password: ""
      },
      sentResetMailAlert: false,      
      enterVefiycodeAlert: false,
      texts: ""
    };
  },
  
  watch: {
    returnLanguage() {
      // eslint-disable-next-line
      if(this.getLanguage == "日本語"){
          // eslint-disable-next-line
          this.texts = loginTextJa
      } else if (this.getLanguage == "English"){
          // eslint-disable-next-line
          this.texts = loginTextEn
      } else if (this.getLanguage == "中文"){
          // eslint-disable-next-line
          this.texts = loginTextCh
      }
    }
  },
  methods: {
    ...mapMutations(["setValueToFormState"]),
    moveToForgotPassword() {
        this.form.username = ""
        this.$store.commit("setValueToFormState", "refreshPassword");
    },
    allAlertDisable() {
      this.sentResetMailAlert = false
      this.enterVefiycodeAlert = false
    },
    async forgotPassword() {
      try {
        const { username } = this.form;
        await Auth.forgotPassword(username);
        this.allAlertDisable()
        this.$store.commit("setValueToFormState", "refreshPasswordSubmit");
      } catch(err) {
        this.sentResetMailAlert = true
        return
      }

    },

    async forgotPasswordSubmit() {
      try{
        const { username, authCode, password } = this.form;
        await Auth.forgotPasswordSubmit(username, authCode, password);
        this.allAlertDisable()
        this.$store.commit("setValueToFormState", "signIn");
      }catch(err){
        this.enterVefiycodeAlert = true
        return
      }
    }
  }
};
</script>

<style lang="scss">
.btn_next {
  display: inline-block;
  color: #fff;
  font-size: 18px;
  padding: 12px 20px 12px 12px;
  min-width: 240px;
  text-align: center;
  background-color: #ff7600;
  border-radius: 28px;
  margin: 8px;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.1);
}
.reset_top_text {
  font-size: 14px;
  text-align: center;
}

.back_to_sent_code_text {
  font-size: 14px;
  text-align: center;
  color: #1D64A1;
}
.auth {
  &_ttl {
    color: #1D64A1;
    text-align: center;
  }
}
</style>